export const siteInfo = {
  name: '屁屁影院',
  slogan: '全网热播，秒播不缓冲',
  description: '屁屁影院是专注高清免费在线观看的影视平台，汇聚海量最新电视剧全集和电影大片。全网资源覆盖，即点即播无需等待，无论热播剧还是经典影片，全部免费在线观看。本站每日更新最新资源，覆盖国产剧、韩剧、美剧、日剧、动漫综艺等全品类内容，致力于为用户提供高清流畅不缓冲的追剧体验。',
  stats: [
    { label: '每日更新', value: '200+' },
    { label: '高清片源', value: '99%' },
    { label: '覆盖剧集', value: '50,000+' },
  ],
  contactInfo: {
    title: '投稿与合作',
    subtitle: '有想看的剧或发现问题？欢迎联系我们',
    email: 'feedback@pipicinema.com',
    qq: '1234567890',
    wechat: 'pipicinema',
  },
};

export const topicTags = [
  { id: 1, name: '暑期档热播', hot: true, count: '128万讨论' },
  { id: 2, name: '完结好剧', hot: true, count: '96万讨论' },
  { id: 3, name: '高分推荐', hot: false, count: '85万讨论' },
  { id: 4, name: '悬疑推理', hot: true, count: '73万讨论' },
  { id: 5, name: '古装仙侠', hot: false, count: '68万讨论' },
  { id: 6, name: '甜宠恋爱', hot: true, count: '61万讨论' },
  { id: 7, name: '日漫新番', hot: false, count: '55万讨论' },
  { id: 8, name: '韩剧精选', hot: true, count: '49万讨论' },
  { id: 9, name: '欧美大片', hot: false, count: '42万讨论' },
  { id: 10, name: '国产经典', hot: false, count: '38万讨论' },
];

export const indexItems = [
  { id: 1, title: '2025暑期热播专题', desc: '暑期档最全追剧指南，热剧一网打尽', tag: '热门' },
  { id: 2, title: '豆瓣8.5+高分合集', desc: '评分最高的口碑好剧一次性推荐', tag: '精选' },
  { id: 3, title: '完结高分剧大盘点', desc: '已完结不烂尾的必看神剧合集', tag: '推荐' },
  { id: 4, title: '韩剧经典回顾', desc: '从《请回答1988》到《黑暗荣耀》', tag: '经典' },
  { id: 5, title: '悬疑烧脑剧场', desc: '反转不断的国产悬疑好剧全收录', tag: '烧脑' },
  { id: 6, title: '国漫崛起专区', desc: '从《凡人修仙传》到《镖人》品质国漫', tag: '国创' },
  { id: 7, title: '甜宠剧甜蜜暴击', desc: '全网最甜恋爱剧合集，嗑糖停不下来', tag: '甜宠' },
  { id: 8, title: '美剧追更日历', desc: '最新美剧更新时间和追剧排期一览', tag: '追更' },
  { id: 9, title: '经典港片回顾', desc: '重温周星驰、成龙等经典港片时代', tag: '怀旧' },
];

export const cardItems = [
  { id: 1, title: '《长安十二时辰》续集定档', desc: '原班人马回归，易烊千玺雷佳音再度联手，古装悬疑巅峰之作第二季正式定档8月15日全网独播。', tag: '新剧定档', date: '2025-07-30' },
  { id: 2, title: '暑期档票房黑马《逆行人生》', desc: '徐峥现实主义新作口碑爆棚，普通人的奋斗故事引发全民共鸣，影院热映中。', tag: '热映推荐', date: '2025-07-28' },
  { id: 3, title: '《鱿鱼游戏》第三季杀青', desc: '李政宰、李秉宪回归，全新游戏规则更加残酷，预计年底上线Netflix。', tag: '海外资讯', date: '2025-07-25' },
  { id: 4, title: '国产科幻《流浪地球3》', desc: '郭帆导演确认第三部已进入后期制作，故事将延伸至太阳系边缘的全新冒险。', tag: '重磅消息', date: '2025-07-22' },
  { id: 5, title: '《庆余年3》剧本完成', desc: '编剧王倦透露第三季剧本打磨已完成，范闲的故事将迎来史诗级收官篇章。', tag: '剧集动态', date: '2025-07-20' },
  { id: 6, title: '周星驰新片《美猴王》', desc: '星爷时隔多年再执导筒，动画电影《美猴王》全球预告片播放量破3亿。', tag: '影坛动态', date: '2025-07-18' },
];

export const mediaItems = [
  { id: 1, title: '《狂飙》—— 年度现象级扫黑剧', desc: '张颂文、张译演技封神，高启强从卖鱼佬到黑道大佬的传奇人生。全国收视冠军。', duration: '全39集', rating: '8.5' },
  { id: 2, title: '《繁花》—— 王家卫首部电视剧', desc: '胡歌、马伊琍、唐嫣主演，九十年代上海滩的商战传奇。金像级画面质感。', duration: '全30集', rating: '8.2' },
  { id: 3, title: '《三体》—— 国产科幻天花板', desc: '刘慈欣原著改编，张鲁一、于和伟主演。人类文明与三体世界的史诗对决。', duration: '全30集', rating: '8.0' },
  { id: 4, title: '《漫长的季节》—— 东北悬疑神作', desc: '范伟、秦昊主演，跨越二十年的碎尸案，一曲时代的挽歌。豆瓣9.4分封神。', duration: '全12集', rating: '9.4' },
];

export const commentItems = [
  { id: 1, user: '追剧小达人', avatar: 'Z', content: '屁屁影院真的太良心了！更新速度比别的站快多了，画质也很清晰，现在追剧只用这一个站。', time: '3小时前', likes: 1286 },
  { id: 2, user: '电影爱好者', avatar: 'M', content: '找了好久的高清资源，终于在屁屁影院找到了。不卡顿不缓冲，体验太好了，强烈推荐给朋友们。', time: '5小时前', likes: 956 },
  { id: 3, user: '追番少女', avatar: 'F', content: '日漫更新超级快！每周追新番的首选平台。而且分类很清晰，找番特别方便，已经安利给全宿舍了。', time: '8小时前', likes: 823 },
  { id: 4, user: '深夜看剧人', avatar: 'S', content: '晚上躺床上用手机看，加载速度飞快，画质也是蓝光级别。不用下载APP直接在网页就能看。', time: '12小时前', likes: 745 },
  { id: 5, user: '剧荒终结者', avatar: 'J', content: '推荐页的算法太懂我了，每次剧荒都能刷到心动的新剧。收藏夹已经加到上限了哈哈哈！', time: '1天前', likes: 612 },
];

export const carouselItems = [
  { id: 1, title: '暑期必看·国产悬疑新高度', subtitle: '《白夜破晓2》', desc: '潘粤明一人分饰两角回归，全新案件更加扑朔迷离。原班制作团队倾力打造，续写国产悬疑剧新标杆。', tag: '独播推荐' },
  { id: 2, title: '年度最受期待·史诗巨制', subtitle: '《大秦帝国之天下》', desc: '投资超5亿，张鲁一、段奕宏领衔，再现秦始皇统一六国的壮阔史诗。服化道极致还原历史。', tag: '即将上线' },
  { id: 3, title: '现象级回归·全球同步', subtitle: '《王国》第三季', desc: '朱智勋、裴斗娜回归，丧尸瘟疫蔓延至整个朝鲜半岛。Netflix与韩国顶级团队联手打造。', tag: '全网首播' },
  { id: 4, title: '国风动画·匠心之作', subtitle: '《深海2》', desc: '田晓鹏导演七年磨一剑，视觉美学再次突破想象边界。讲述少年在深海世界的奇幻冒险旅程。', tag: '品质国漫' },
];

export const appInfo = {
  title: '屁屁影院 APP',
  subtitle: '随时随地，高清追剧不缓冲',
  desc: '支持 iOS 和 Android，下载 APP 享受离线缓存、弹幕互动、画质切换等专属功能。新用户注册即送7天VIP体验。',
  features: ['离线缓存', '弹幕互动', '画质随心切换', '追剧提醒', '无广告纯净模式'],
};

export const rankingItems = [
  { rank: 1, title: '庆余年 第二季', type: '古装·权谋', hot: '🔥 980万热度', change: 'up' },
  { rank: 2, title: '繁花', type: '年代·商战', hot: '🔥 875万热度', change: 'up' },
  { rank: 3, title: '狂飙', type: '扫黑·悬疑', hot: '🔥 820万热度', change: 'same' },
  { rank: 4, title: '三体', type: '科幻·巨制', hot: '🔥 756万热度', change: 'down' },
  { rank: 5, title: '莲花楼', type: '武侠·探案', hot: '🔥 698万热度', change: 'up' },
  { rank: 6, title: '长相思', type: '古装·奇幻', hot: '🔥 642万热度', change: 'new' },
  { rank: 7, title: '漫长的季节', type: '悬疑·生活', hot: '🔥 589万热度', change: 'same' },
];

export const featureItems = [
  { id: 1, title: '蓝光高清画质', desc: '全站支持1080P和4K超清画质，给你影院级观影体验，每一帧都清晰细腻。', icon: 'ri-4k-fill' },
  { id: 2, title: '极速秒播不缓冲', desc: '全球多节点CDN加速，即点即播无需等待。智能预加载技术，看剧流畅到底。', icon: 'ri-speed-up-fill' },
  { id: 3, title: '海量片源覆盖', desc: '国产剧、韩剧、美剧、日剧、动漫、综艺全覆盖，每日更新200+部最新内容。', icon: 'ri-database-2-fill' },
  { id: 4, title: '智能推荐系统', desc: '基于你的观影偏好，精准推荐你可能喜欢的内容，告别剧荒发现更多好片。', icon: 'ri-magic-fill' },
  { id: 5, title: '多端同步观看', desc: '支持手机、平板、电脑多设备无缝切换，观影记录自动同步，随时随地继续看。', icon: 'ri-device-fill' },
];

export const updateItems = [
  { id: 1, date: '07-30', title: '《白夜破晓2》第5-8集更新', desc: '潘粤明、王泷正主演悬疑剧最新剧情推进，案件出现重大转折。' },
  { id: 2, date: '07-30', title: '《庆余年2》全集上线', desc: '张若昀、陈道明主演，范闲南下江南开启全新篇章，热度登顶。' },
  { id: 3, date: '07-29', title: '《繁花》沪语版独家上线', desc: '胡歌、马伊琍原声沪语演绎，还原最地道的九十年代上海风华。' },
  { id: 4, date: '07-28', title: '《三体》4K修复版更新', desc: '画面全面升级4K画质，视觉效果更加震撼，科幻迷不可错过。' },
  { id: 5, date: '07-27', title: '《唐朝诡事录2》超前点播', desc: '杨旭文、杨志刚主演古装探案，长安城中离奇案件接连上演。' },
  { id: 6, date: '07-26', title: '《与凤行》全集4K上线', desc: '赵丽颖、林更新二搭古装仙侠，九鹭非香原著IP改编高甜虐恋。' },
  { id: 7, date: '07-25', title: '《异人之下2》定档预告', desc: '彭昱畅、侯明昊回归，异人世界全新篇章即将开启，预约已破百万。' },
];

export const faqItems = [
  { id: 1, question: '屁屁影院需要注册才能看吗？', answer: '不需要！屁屁影院所有内容完全免费，无需注册登录即可在线观看。打开网站就能直接点播，没有次数限制。如果你希望收藏剧集或同步观看记录，可以自愿注册账号。' },
  { id: 2, question: '观看时需要安装播放器或插件吗？', answer: '完全不需要。屁屁影院采用H5播放技术，主流浏览器（Chrome、Safari、Edge、Firefox）均可直接播放，无需安装任何插件或播放器。' },
  { id: 3, question: '画质怎么样？会卡顿吗？', answer: '屁屁影院全站支持1080P高清和4K超清画质，采用多节点CDN全球加速，智能自适应码率技术会根据你的网络状况自动调整，确保流畅播放不缓冲。' },
  { id: 4, question: '手机和平板能看吗？', answer: '当然可以！屁屁影院完美适配手机、平板和电脑。手机浏览器直接访问就能看，还支持投屏到电视。也可以下载屁屁影院APP享受离线缓存功能。' },
  { id: 5, question: '更新频率怎么样？新剧什么时候上？', answer: '我们每天更新200+部内容，热播剧通常在电视台播出后2小时内上线，同步海外剧集更新。关注首页更新动态，第一时间获取最新上线信息。' },
];

export const aboutInfo = {
  title: '关于屁屁影院',
  content: '屁屁影院成立于2020年，是一个致力于为全球华语用户提供免费高清影视在线观看的平台。我们相信好的内容应该被更多人看到，因此始终坚持以用户为中心，不断优化播放体验和内容覆盖。从最初的几十部影片起步，到今天涵盖国产剧、韩剧、美剧、日剧、动漫、综艺、纪录片等全品类超过五万部作品，屁屁影院已经成为数千万用户信赖的在线观影首选。我们团队分布在全球多个地区，通过先进的CDN技术和智能推荐算法，为用户提供秒播不缓冲的高清观影体验。未来，屁屁影院将继续努力，让每一位用户都能在这里找到自己喜欢的好内容。',
};